import retryWhileUnreachable from "@/core/http/retryWhileUnreachable";

/**
 * The longest wait before a spread request.
 *
 * Counter PCs start at the pharmacies' opening hour: up to a thousand Connect
 * boot within the same minute and their startup requests saturate the API.
 * A minute is enough to flatten that wave, and short enough for what only
 * feeds a badge or a counter.
 */
const DEFAULT_MAX_DELAY = 60_000;

/**
 * Run a startup request the screen does not wait for, after a random delay.
 *
 * Fire and forget: the request is still run again while the API is
 * unreachable, and a final failure is ignored, as the data it loads is not
 * needed to use Connect.
 *
 * @param request The request to run.
 * @param maxDelay The longest wait before running it.
 */
export default function spreadStartupRequest(
    request: () => Promise<unknown>,
    maxDelay: number = DEFAULT_MAX_DELAY
): void {
    setTimeout(() => {
        retryWhileUnreachable(request).catch(() => undefined);
    }, Math.random() * maxDelay);
}
